import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "list"]

  connect() {
    this._onClickOutside = this._onClickOutside.bind(this)
    this._onKeydown = this._onKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this._onClickOutside)
    document.removeEventListener("keydown", this._onKeydown)
  }

  toggle() {
    if (this.dropdownTarget.classList.contains("notification-dropdown--open")) {
      this._close()
    } else {
      this._open()
    }
  }

  _open() {
    // Close any open user-menu dropdowns
    document.querySelectorAll(".show[data-user-menu-target='dropdown']").forEach(el => {
      el.classList.remove("show")
    })

    this.dropdownTarget.classList.add("notification-dropdown--open")
    requestAnimationFrame(() => {
      document.addEventListener("click", this._onClickOutside)
      document.addEventListener("keydown", this._onKeydown)
    })

    // Lazy fetch notifications
    fetch("/notifications", {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      }
    })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
  }

  _close() {
    this.dropdownTarget.classList.remove("notification-dropdown--open")
    document.removeEventListener("click", this._onClickOutside)
    document.removeEventListener("keydown", this._onKeydown)
  }

  _onClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this._close()
    }
  }

  _onKeydown(event) {
    if (event.key === "Escape") {
      this._close()
    }
  }

  clickNotification(event) {
    const item = event.currentTarget
    const notificationId = item.dataset.notificationId
    const path = item.dataset.notificationPath
    const isRead = item.dataset.read === "true"

    // Mark as read if unread
    if (!isRead) {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      fetch(`/notifications/${notificationId}/read`, {
        method: "PATCH",
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": token
        }
      })
        .then(response => response.text())
        .then(html => {
          Turbo.renderStreamMessage(html)
        })
    }

    // Navigate to the related page
    if (path) {
      this._close()
      Turbo.visit(path)
    }
  }

  markAllRead(event) {
    event.preventDefault()
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch("/notifications/mark_all_read", {
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": token
      }
    })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
  }

  markAllUnread(event) {
    event.preventDefault()
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch("/notifications/mark_all_unread", {
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": token
      }
    })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
  }
}
